import React from "react";
import { AlbumEidtingFaq } from "./FaqsData";

const AlbumEditingFaqs = () => {
  return (
    <div className="bg-light">
      <div className="container py-5 ">
        <div className="py-5">
          <h1 className="prata-regular text-center mb-4 fs-2">
            Album Design FAQ
          </h1>
          <div className="accordion accordion-flush" id="accordionFlushExample">
            {AlbumEidtingFaq.map((val, index) => (
              <div className="accordion-item bg-transparent" key={index}>
                <h2 className="accordion-header" id={`flush-heading-${index}`}>
                  <button
                    className="accordion-button collapsed shadow-none bg-transparent fw-600"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#flush-collapse-${index}`}
                    aria-expanded="false"
                    aria-controls={`flush-collapse-${index}`}
                  >
                    {val.question}
                  </button>
                </h2>
                <div
                  id={`flush-collapse-${index}`}
                  className="accordion-collapse collapse"
                  aria-labelledby={`flush-heading-${index}`}
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">{val.answer}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlbumEditingFaqs;
